import { useDrawingArea } from '@mui/x-charts/hooks';

export type ChartGradientPT = {
  firstStopColor?: string;
  firstStopOpacity?: string;
  secondStopColor?: string;
  secondStopOpacity?: string;
  gradientId?: string;
};
export const ChartGradient = (props: ChartGradientPT) => {
  const {
    firstStopColor = '#89E87E',
    firstStopOpacity = '0.3',
    secondStopColor = '#60CD5A',
    secondStopOpacity = '0',
    gradientId,
  } = props;
  const { top, height, bottom } = useDrawingArea();
  const svgHeight = top + bottom + height;

  return (
    <defs>
      <linearGradient
        id={gradientId}
        x1="0"
        y1="0"
        x2="0"
        y2={svgHeight}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={firstStopColor} stopOpacity={firstStopOpacity} />
        <stop offset="1" stopColor={secondStopColor} stopOpacity={secondStopOpacity} />
      </linearGradient>
    </defs>
  );
};
